import { format, parseISO } from "date-fns";
import { isRevenueRecognitionPeriodKey } from "@common/schemas/domains/accounting/scheduleReview.schema";
import {
    Task,
    parseRevenueRecognitionReviewPeriodKey,
} from "@common/types/task";

export function getRecognitionPeriodKey(
    task: Pick<Task, "metadata" | "systemKey">,
): string | null {
    const metadataPeriodKey = task.metadata?.periodKey;
    if (metadataPeriodKey && isRevenueRecognitionPeriodKey(metadataPeriodKey)) {
        return metadataPeriodKey;
    }
    return parseRevenueRecognitionReviewPeriodKey(task.systemKey);
}

export function formatPeriodKeyLabel(periodKey: string): string {
    return format(parseISO(`${periodKey}-01`), "MMMM yyyy");
}

export function formatEffectiveDate(effectiveDate: string): string {
    return format(parseISO(effectiveDate), "MMM d, yyyy");
}
